import nodeFetch from 'node-fetch';

import store from './store';
import config from './config';

const crFetch = (props, api = config.apiUrl.orionAPI) => {
  const { me } = store.getState().entities.auth;

  const requestOptions = {
    method: props.method,
    headers: { Authorization: `Bearer ${me.token}` }
  };

  if (props.body) {
    requestOptions.body = props.body;
  }

  if (!props.multipart) {
    requestOptions.headers = {
      ...requestOptions.headers,
      'Content-Type': 'application/json'
    };
  }

  return nodeFetch(`${api}${props.url}`, requestOptions);
};

export default crFetch;
